import { createEntityAdapter, createSelector } from '@reduxjs/toolkit';
import { apiSlice } from './api';
import { ListParams, Teacher } from '../types/classroom';
import { ResponseBody } from '../types/common';
import { RootState } from './store';

const teacherAdapter = createEntityAdapter({
  selectId: (data: Teacher) => data.seq,
});
const initialState = teacherAdapter.getInitialState({ totalCnt: 0 });

export const teacherApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTeacher: builder.query({
      query: ({ page = 0, search = '', size = 30 }: ListParams) => ({
        url: 'library/school/mgmt/teacher',
        params: { page, search, size },
      }),
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
      merge: (currentCache, newItems, { arg }) => {
        if (arg.page && arg.page > 0) {
          currentCache.ids.push(...newItems.ids);
          currentCache.ids = [...new Set(currentCache.ids)];
          currentCache.entities = {
            ...currentCache.entities,
            ...newItems.entities,
          };
        } else {
          return newItems;
        }
      },
      forceRefetch({ currentArg, previousArg }) {
        return JSON.stringify(currentArg) !== JSON.stringify(previousArg);
      },
      transformResponse: (res: ResponseBody) => {
        initialState.totalCnt = res.data.totalCnt;
        return teacherAdapter.setAll(initialState, res.data.teacherList);
      },
      providesTags: (result, error, arg) => {
        return ['Teacher'];
      },
    }),
    deleteTeacher: builder.mutation({
      query: (seq) => ({
        url: `library/school/mgmt/teacher/${seq}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const { useGetTeacherQuery, useDeleteTeacherMutation } = teacherApiSlice;

export const selectTeacherResult = teacherApiSlice.endpoints.getTeacher.select(
  {}
);

const selectTeacherData = createSelector(
  selectTeacherResult,
  (teacherResult) => teacherResult.data
);

export const {
  selectAll: selectAllTeacher,
  selectById: selectTeacherById,
  selectIds: selectTeacherIds,
  selectTotal: selectTotalTeacherNum,
} = teacherAdapter.getSelectors(
  (state: RootState) => selectTeacherData(state) ?? initialState
);
